import Configuration from "./Configuration";

class Notifier {
  constructor() {
    const {components} = Configuration,
      {Notifier: ConfiguredNotifier} = components;

    Object.assign(this, ConfiguredNotifier);
  }

  addNotification(...rest) {
    const {hooks, components} = Configuration,
      {notification} = hooks,
      {Notifier: ConfiguredNotifier} = components;

    if (notification) {
      notification(...rest);
      return;
    }

    ConfiguredNotifier && ConfiguredNotifier.addNotification(...rest);
  }
}

const Initializer = () => {
  if (!window.atsSecurityRibbonNotifier) {
    window.atsSecurityRibbonNotifier = new Notifier();
  }
  return window.atsSecurityRibbonNotifier;
};

export default Initializer();
